export default __webpack_public_path__ + "static/media/twaboriginalBlog.5b2c6ac9.png";